module.exports = __webpack_public_path__ + "static/assets/0fc3a55bd234d2ab148a273b5d5ce811.svg";